define.alias("shared/components/shared/mavely/logo-badge", "calendar/components/shared/mavely/logo-badge");